import Scene = Phaser.Scene;
import BadgePanel from "@/scenes.ui/badge-panel";
import {Badge} from "@/store/profile/types";
import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export default class ProfileBadgesNavPanel extends AbstractNavPanel {

    private onBadgeClickCallback!: (badgePanel: BadgePanel) => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, badges: Badge[],
                onBadgeClickCallback: (badgePanel: BadgePanel) => unknown, maxDisplayedElements: number) {
        super(scene, canvas, x, y, badges, maxDisplayedElements);

        this.x = x;
        this.y = y;

        this.onBadgeClickCallback = onBadgeClickCallback;

    }

    protected makePanel(x: number, element: any): any {

        let badgePanel = new BadgePanel(this.scene!, x * CU.S, 30 * CU.S, <Badge>element);
        SpriteUtils.scale(badgePanel, 0.7);
        badgePanel.setDepth(1000);

        badgePanel.setClickCallback(() => {
            if (this.onBadgeClickCallback != null) {
                this.playSelectSound();
                this.onBadgeClickCallback(badgePanel);
            }
        });

        return badgePanel;
    }

    protected getButtonX(): number {
        return 250;
    }

    protected getButtonY(): number {
        return 30;
    }

    protected getMaxDisplayedElements(): number {
        return 5;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return 96;
    }



}

